import {
  Component, ChangeDetectionStrategy, Input, ViewChild,
  ElementRef, Output, EventEmitter
} from '@angular/core';
import * as Flatpickr from 'flatpickr';

interface IFlatPickrDateObject {
  currentMonth?: number;
  currentYear?: number;
}
export class FlatPickrComponent {

   calendar: ElementRef;
   placeholder = 'Select Date..';
   className = 'calendarInput';
/**
 * @param {?} data
 * @return {?}
 */
set options(data: object) {
    this.localOptions = Object.assign(this.localOptions, data || {});
  }
private flatpickrInstance: Flatpickr;
private localOptions = {
    onChange: (changeData: Date[]) => {
      const [ date ] = changeData;

      this.onChange.next(date);
    },
    onOpen: () => {
      this.onOpen.next(true);
    },
    onClose: (selectedData: Date[]) => {
      const [ date ] = selectedData;

      this.onClose.next(date);
    },
    onMonthChange: (a: IFlatPickrDateObject, b: IFlatPickrDateObject, c: IFlatPickrDateObject) => {
      this.onMonthChange.next(c.currentMonth + 1);
    },
    onYearChange: (a: IFlatPickrDateObject, b: IFlatPickrDateObject, c: IFlatPickrDateObject) => {
      this.onYearChange.next(c.currentYear);
    },
    onReady: () => {
      this.onReady.next(true);
    },
    onValueUpdate: (a: Date[]) => {
      const [ date ] = a;

      this.onValueUpdate.next(date);
    }
  };
   onChange: EventEmitter<Date> = new EventEmitter<Date>();
   onOpen: EventEmitter<boolean> = new EventEmitter<boolean>();
   onClose: EventEmitter<Date> = new EventEmitter<Date>();
   onMonthChange: EventEmitter<number> = new EventEmitter<number>();
   onYearChange: EventEmitter<number> = new EventEmitter<number>();
   onReady: EventEmitter<boolean> = new EventEmitter<boolean>();
   onValueUpdate: EventEmitter<Date> = new EventEmitter<Date>();
/**
 * @return {?}
 */
ngOnInit() {
    this.flatpickrInstance = new Flatpickr(this.calendar.nativeElement, this.localOptions);
  }
/**
 * @return {?}
 */
getInstance() {
    return this.flatpickrInstance;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ngx-flatpickr',
  template: "<input #calendar class=\"{{className}}\" type=\"text\" [placeholder]=\"placeholder\" readonly=\"readonly\"> ",
  styles: [".calendarInput { border: 1px solid #c3c3c3; width: 100%; padding: 8px; max-width: 360px; border-radius: 3px; background: #fff; cursor: pointer; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'calendar': [{ type: ViewChild, args: ['calendar', ] },],
'placeholder': [{ type: Input },],
'className': [{ type: Input },],
'options': [{ type: Input },],
'onChange': [{ type: Output },],
'onOpen': [{ type: Output },],
'onClose': [{ type: Output },],
'onMonthChange': [{ type: Output },],
'onYearChange': [{ type: Output },],
'onReady': [{ type: Output },],
'onValueUpdate': [{ type: Output },],
};
}

function FlatPickrComponent_tsickle_Closure_declarations() {
/** @type {?} */
FlatPickrComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FlatPickrComponent.ctorParameters;
/** @type {?} */
FlatPickrComponent.propDecorators;
/** @type {?} */
FlatPickrComponent.prototype.calendar;
/** @type {?} */
FlatPickrComponent.prototype.placeholder;
/** @type {?} */
FlatPickrComponent.prototype.className;
/** @type {?} */
FlatPickrComponent.prototype.flatpickrInstance;
/** @type {?} */
FlatPickrComponent.prototype.localOptions;
/** @type {?} */
FlatPickrComponent.prototype.onChange;
/** @type {?} */
FlatPickrComponent.prototype.onOpen;
/** @type {?} */
FlatPickrComponent.prototype.onClose;
/** @type {?} */
FlatPickrComponent.prototype.onMonthChange;
/** @type {?} */
FlatPickrComponent.prototype.onYearChange;
/** @type {?} */
FlatPickrComponent.prototype.onReady;
/** @type {?} */
FlatPickrComponent.prototype.onValueUpdate;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
